import React, { useEffect, useState } from 'react';
import './navbar.css'
import { NavLink } from "react-router-dom";
import { useNavigate } from 'react-router-dom'
import Logo from '../../assets/navbar/logo.svg';
import { CircleUserRound, User, KeyRound, LogOut, LogIn } from 'lucide-react';
import { ApiHelper } from '../../utilFunctions/utilfunction';
import ChangePassword from '../auth/changePassword';
const Navbar = () => {

  useEffect(() => {

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    let leftside = document.getElementById("dropdown_left");
    let rightside = document.getElementById("dropdown_right");

    window.addEventListener('scroll', (event) => {

      leftside.classList.remove('show');
      rightside.classList.remove('show');
      setShowResults(false);
    })


  }, [window.location.pathname])

  const userId = localStorage.getItem('user_id')
  let navigate = useNavigate();

  const [showResults, setShowResults] = useState(false);


  const toggledropdown = () => {

    if (showResults === false) {

      setShowResults(true);
      let a = document.getElementById("dropdown_image")
      a.classList.add("active")
    }
    if (showResults === true) {
      setShowResults(false);
      let b = document.getElementById("dropdown_image")
      b.classList.remove("active")
    }

  }
  const rolex = () => {

    navigate("/rolex")
    let b = document.getElementById("unique")
    b.classList.add("active")

  }
  const vintage = () => {

    navigate("/vintage-rolex-watches")
    let c = document.getElementById("unique")
    c.classList.add("active")

  }

  const vintageWatchPart = () => {

    navigate("/watches-and-parts")
    let c = document.getElementById("unique")
    c.classList.add("active")

  }

  const archive = () => {

    navigate("/archive")
    let d = document.getElementById("unique")
    d.classList.add("active")
  }
  const navbarlink = () => {

    let e = document.getElementById("unique")
    e.classList.remove("active")

    let f = document.getElementById("dropdown_image")
    f.classList.remove("active")
    setShowDropdown(false);
    setShowResults(false)
    console.log();
  }

  setTimeout(() => {
    if (window.location.pathname === '/vintage-rolex-watches' || window.location.pathname === '/rolex' || window.location.pathname === "/vintage" || window.location.pathname === "/vintagedetail" || window.location.pathname === "/vintagepurchase" || window.location.pathname === "/rolexdetail" || window.location.pathname === "/rolexpurchase" || window.location.pathname === "/watches" || window.location.pathname === "/purchase-watch" || window.location.pathname === "/archive" || window.location.pathname === "/archivedetail") {

      let l = document.getElementById("unique");
      l.classList.add("active")
    }
  }, 1000)

  setTimeout(() => {

    if (window.location.pathname === '/archive-articles' || window.location.pathname === "/articles" || window.location.pathname === "/contact-us" || window.location.pathname === "/sell-your-watch" || window.location.pathname === "/privacy-policy") {

      let g = document.getElementById("unique");
      g.classList.remove("active")

      if (g.className === "nav-link position-relative pe-3 cursor-pointer active") {
        g.classList.remove("active")
      }
    }
  }, 1000);

  setTimeout(() => {
    if (window.location.pathname === '/rolexdetail') {

      let h = document.getElementById("unique");

      h.classList.add("active")

    }
  }, 1000);

  const [openDialog, setOpenDialog] = useState(false);
  setTimeout(() => {
    const pathname = window.location.pathname;

    // Helper to safely add/remove class
    const setClass = (id, className, condition) => {
      const el = document.getElementById(id);
      if (!el) return;
      condition ? el.classList.add(className) : el.classList.remove(className);
    };

    // Rolex routes
    const rolexRoutes = ["/rolex", "/rolexdetail", "/rolexpurchase"];
    setClass("rolex_submenu_active", "smallactive", rolexRoutes.includes(pathname));
    setClass("unique", "active2", rolexRoutes.includes(pathname));

    // Vintage routes
    const vintageRoutes = ["/vintage", "/vintagedetail", "/vintagepurchase", "/vintage-rolex-watches"];
    setClass("vintage_submenu_active", "smallactive", vintageRoutes.includes(pathname));

    // Archive routes
    const archiveRoutes = ["/archive", "/archivedetail"];
    setClass("archive_submenu_active", "smallactive", archiveRoutes.includes(pathname));

    // Articles / blog
    setClass("articlee", "active", ["/articles", "/archive-articles"].includes(pathname));
    setClass("blog", "active", pathname.includes("/blog") || pathname.includes("/blogs"));

    // Watches / collection routes
    const watchPartRoutes = ["/purchase-watches-and-part", "/watches-and-parts"];
    const collectionRoutes = ["/purchase-watch", "/watches", "/vintage-rolex-watches"];

    setClass("watches-and-parts", "active", watchPartRoutes.includes(pathname));
    setClass("unique", "active", !watchPartRoutes.includes(pathname) && collectionRoutes.includes(pathname));
  }, 500);

  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => setShowDropdown(!showDropdown);
  const closeDropdown = () => setShowDropdown(false);
  const handleLogout = async () => {
    const accessToken = localStorage.getItem("access_token");

    if (!accessToken) {
      console.warn("No access token found.");
      return;
    }
    const token = localStorage.getItem("access_token"); // or whatever your token key is

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await ApiHelper("/logout", {}, "POST", headers);
      if (response?.status === true) {
        // Clear localStorage and redirect to login
        localStorage.removeItem("access_token");
        localStorage.removeItem("user_id");
        setShowDropdown(false);
        // Redirect or update UI accordingly
        navigate('/');
      } else {
        console.error("Logout failed:");
      }
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (

    <section>

      <header className="header container-fluid">
        <nav className="navbar container container23 navbar-expand-lg navbar-light">

          <div className="container-fluid cont_fluid">

            {/* navbar  leftside */}
            <div id="dropdown_left" className="collapse navbar-collapse order-lg-1 order-3 navigation-menu">
              <ul className="navbar-nav">
                <li className="homeee text-uppercase nav-item fs-14 fw-500">
                  <NavLink exact to="/introduction" className="nav-link" onClick={() => navbarlink()}>
                    Home
                  </NavLink>
                </li>
                <li className="collectionnn text-uppercase nav-item fs-14 fw-500">
                  <div className="nav-link position-relative pe-3 cursor-pointer" id="unique" onClick={() => toggledropdown()}>
                    Our Collection
                    <svg className="svg-inline--fa fa-chevron-down fa-w-14 fa-3x position-absolute" id="dropdown_image" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z">
                      </path>
                    </svg>
                    {showResults && (
                      <div className='dropdown_menu d-flex flex-column'>
                        <a onClick={() => vintage()} id="vintage_submenu_active" className='text-decoration-none color-primary m-0 pt-2 pt-lg-0 cursor-pointer'>Discover Our Vintage Rolex Collection</a>
                      </div>
                    )}
                  </div>
                </li>
                <li className="watch-parts text-uppercase nav-item fs-14 fw-500">
                  <NavLink exact to="/watches-and-parts" id="watches-and-parts" className="nav-link" onClick={() => navbarlink()}>
                    Watches and Parts
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* navbar center icon */}
            <NavLink to="/" className="navbar-brand order-1" onClick={() => navbarlink()}>
              <img className='brand_logo' src={Logo} id="white_logo" alt="White_logo" />
            </NavLink>
            <div className="d-flex align-items-center order-2 ms-auto">
              <button
                className="navbar-toggler custom-toggler me-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target=".navigation-menu"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* User Icon next to hamburger */}

              <div className="d-lg-none">
                <span
                  className="ms-2 user-icon"
                  onClick={toggleDropdown}
                  style={{ cursor: 'pointer', marginRight: '20px' }}
                >
                  <CircleUserRound size={20} />
                </span>

                {showDropdown && userId !== null && (
                  <div
                    className="dropdown_menu bg-white border rounded shadow"
                    style={{
                      position: 'fixed',
                      top: '58px',
                      fontSize: '16px',
                      right: '-142px',
                      left: 'auto',

                      transform: 'translateX(-100%)',

                      padding: '10px',
                      textAlign: 'center',
                      borderRadius: '5px',
                      zIndex: 999,
                      boxShadow: '10px 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)'
                    }}
                  >
                    <NavLink
                      to="/profile"
                      className={({ isActive }) =>
                        `menu-item-hover ${isActive ? 'active-link' : ''}`
                      }
                    >
                      <User size={14} />
                      <span>Profile</span>
                    </NavLink>

                    <hr className="my-1" />

                    <NavLink
                      to="/change-password"
                      className={({ isActive }) =>
                        `menu-item-hover ${isActive ? 'active-link' : ''}`
                      }
                    >
                      <KeyRound size={14} />
                      <span>Change Password</span>
                    </NavLink>

                    {openDialog && (
                      <div className="modal-overlay">
                        <div className="modal-content">
                          <button onClick={() => setOpenDialog(false)} className="close-btn">X</button>
                          <ChangePassword />
                        </div>
                      </div>
                    )}

                    <hr className="my-1" />

                    <div
                      className="menu-item-hover"
                      onClick={handleLogout}
                      style={{ cursor: 'pointer' }}
                    >
                      <LogOut size={14} />
                      <span>Logout</span>
                    </div>


                  </div>
                )}
                {showDropdown && userId === null && (


                  <div
                    className="dropdown_menu bg-white border rounded shadow"
                    style={{
                      position: 'fixed',
                      top: '58px',
                      fontSize: '16px',
                      right: '-65px',
                      left: 'auto',

                      transform: 'translateX(-100%)',

                      padding: '10px',
                      textAlign: 'center',
                      borderRadius: '5px',
                      zIndex: 999,
                      boxShadow: '10px 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)'
                    }}
                  >
                    <NavLink
                      to="/login"
                      onClick={() => setShowDropdown(false)}
                      className={({ isActive }) =>
                        `menu-item-hover ${isActive ? 'active-link' : ''}`
                      }
                    >
                      <LogIn size={14} />
                      <span>Login</span>
                    </NavLink>




                  </div>
                )}
              </div>


            </div>

            {/* navbar rightside */}
            <div id="dropdown_right" className="right collapse navbar-collapse order-lg-3 order-4 navigation-menu">
              <ul className="navbar-nav">
                <li className="articlee text-uppercase nav-item fs-14 fw-500">
                  <NavLink
                    exact
                    to={userId ? "/archive-articles" : "/authpage"}
                    id="articlee"
                    className="nav-link"
                    onClick={() => navbarlink()}
                  >
                    Articles
                  </NavLink>
                </li>
                <li className="blogg text-uppercase nav-item fs-14 fw-500">
                  <NavLink exact="true" id="blog" to="/blog" className="nav-link" onClick={() => navbarlink()}>
                    Blogs
                  </NavLink>
                </li>
                <li className="watchh text-uppercase nav-item fs-14 fw-500">
                  <NavLink exact="true" id="sellwatch" to="/sell-your-watch" className="nav-link" onClick={() => navbarlink()}>
                    Sell your Watch
                  </NavLink>
                </li>

                <li className="contactt text-uppercase nav-item fs-14 fw-500">
                  <NavLink exact="true" to="/contact-us" className="nav-link" onClick={() => navbarlink()}>
                    Contact Us
                  </NavLink>
                </li>
                <div className="d-none bg-red-500 d-lg-block" style={{ margin: "5px 5px 5px -10px" }}>

                  <li className="contactt text-uppercase nav-item fs-14 fw-500" style={{ marginRight: '12px' }}>

                    <span
                      className="ms-2 user-icon"
                      onClick={toggleDropdown}
                      style={{ cursor: 'pointer', marginRight: '20px' }}
                    >
                      <CircleUserRound size={20} />
                    </span>
                    <>


                      {showDropdown && userId !== null && (


                        <div
                          className="dropdown_menu bg-white border rounded shadow"
                          style={{
                            position: 'fixed',
                            top: '58px',
                            fontSize: '14px',
                            right: '-140px',
                            left: 'auto',

                            transform: 'translateX(-100%)',

                            padding: '10px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            zIndex: 999,
                            boxShadow: '10px 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)'
                          }}
                        >
                          <NavLink
                            to="/profile"
                            onClick={() => setShowDropdown(false)}
                            className={({ isActive }) =>
                              `menu-item-hover ${isActive ? 'active-link' : ''}`
                            }
                          >
                            <User size={14} />
                            <span>Profile</span>
                          </NavLink>

                          <hr className="my-1" />

                          <NavLink
                            to="/change-password"
                            onClick={() => setShowDropdown(false)}
                            className={({ isActive }) =>
                              `menu-item-hover ${isActive ? 'active-link' : ''}`
                            }
                          >
                            <KeyRound size={14} />
                            <span>Change Password</span>
                          </NavLink>

                          {openDialog && (
                            <div className="modal-overlay">
                              <div className="modal-content">
                                <button onClick={() => setOpenDialog(false)} className="close-btn">X</button>
                                <ChangePassword />
                              </div>
                            </div>
                          )}

                          <hr className="my-1" />

                          <div
                            className="menu-item-hover"
                            onClick={handleLogout}
                            style={{ cursor: 'pointer' }}
                          >
                            <LogOut size={14} />
                            <span>Logout</span>
                          </div>


                        </div>
                      )}
                      {showDropdown && userId === null && (


                        <div
                          className="dropdown_menu bg-white border rounded shadow"
                          style={{
                            position: 'fixed',
                            top: '58px',
                            fontSize: '14px',
                            right: '-65px',
                            left: 'auto',

                            transform: 'translateX(-100%)',

                            padding: '10px',
                            textAlign: 'center',
                            borderRadius: '5px',
                            zIndex: 999,
                            boxShadow: '10px 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22)'
                          }}
                        >
                          <NavLink
                            to="/login"
                            onClick={() => setShowDropdown(false)}
                            className={({ isActive }) =>
                              `menu-item-hover ${isActive ? 'active-link' : ''}`
                            }
                          >
                            <LogIn size={14} />
                            <span>Login</span>
                          </NavLink>




                        </div>
                      )}
                    </>

                  </li>
                </div>
              </ul>
            </div>

          </div>

        </nav>
      </header >

    </section >
  )
}

export default Navbar;
